/* istanbul ignore file */
// Added 4 more new tests to check how Accordion and Tabs work together
import { Accordion, Tabs } from '@distribusion/owl-frontend-ui'
import cn from 'classnames'
import React, { ReactNode, useState } from 'react'

import bem from '@lib/bem'

import '@components/FAQTabs/index.scss'

interface Topic {
  title: string
  content: ReactNode
}

interface TabContent {
  title: string
  items: Topic[]
}

export interface OpenedItemsMap {
  [tabIndex: number]: number[]
}

export interface FAQTabsProps {
  tabs: TabContent[]
  title: string
  description: string
}

const FAQTabs = (props: FAQTabsProps) => {
  const { tabs, title, description } = props

  const [activeTab, setActiveTab] = useState(0)
  const [openedItemsMap, setOpenedItemsMap] = useState<OpenedItemsMap>({})

  const currentTabOpenedContent = openedItemsMap[activeTab] || []

  const tabsOptions = tabs.map((tab, index) => ({ value: index, label: tab.title }))
  const activeTabData = tabs[activeTab]

  const handleTabChange = (index: number) => {
    setActiveTab(index)
  }

  const handleAccordionChange = (itemIndex: number, isOpen: boolean) => {
    setOpenedItemsMap(prev => {
      const currentlyOpenedContent = prev[activeTab] || []
      let newlyOpenedContent

      if (isOpen) {
        newlyOpenedContent = currentlyOpenedContent.includes(itemIndex)
          ? currentlyOpenedContent
          : [...currentlyOpenedContent, itemIndex]
      } else {
        newlyOpenedContent = currentlyOpenedContent.filter((idx: number) => idx !== itemIndex)
      }

      return {
        ...prev,
        [activeTab]: newlyOpenedContent,
      }
    })
  }

  if (!activeTabData || !activeTabData.items || !activeTabData.items.length) {
    return null
  }

  return (
    <div className="column gap-3 faq-tabs">
      <h3 className="mb-2">{title}</h3>
      <div className={cn('body-14  mb-1', bem('faq-tabs', 'description'))}>{description}</div>
      <div className={cn('cell', bem('faq-tabs', 'content'))}>
        <div className="column">
          <div className={bem('faq-tabs', 'navigation')}>
            <Tabs options={tabsOptions} value={activeTab} onClick={handleTabChange} />
          </div>
          {activeTabData.items.map((item, index) => (
            <Accordion
              key={`${activeTab}-${index}`}
              titleClassName="body-14 bolder"
              title={item.title}
              opened={currentTabOpenedContent.includes(index)}
              onChange={isOpen => handleAccordionChange(index, isOpen)}
            >
              <div className="body-14 pb-2">{item.content}</div>
            </Accordion>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FAQTabs
